export default __webpack_public_path__ + "static/media/ic-close-black.74e5d0db.svg";